var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('div',{staticClass:"vx-row mb-12"},[_c('div',{class:[
        _vm.mutualAction == 'edit' || _vm.mutualAction == 'create' ? _vm.detailShow : '',
        _vm.detailHide,
      ]},[_c('data-table',{attrs:{"baseUrl":_vm.baseUrl,"action":_vm.mutualAction,"status":1,"supplier":_vm.selectedSuppliers.ID,"customerCategory":_vm.customerCategory,"topmodel":_vm.selectedTopModels.value,"isFilter":_vm.isFilters},on:{"id":_vm.setId,"action":_vm.setAction,"isFilter":_vm.setFilter}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }